import { Button } from '@sravni/react-design-system/lib/Button';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { DEFAULT_FILTERS } from '../../constants/filters';
import { useFilters } from '../../store/hooks/filters';
import { makeFiltersLink } from '../../utils/routing';

import styles from './empty-rating.module.scss';

export const EmptyRating = () => {
  const filters = useFilters();
  const { organizationType } = filters;
  const cx = useStyles(styles);
  const orgHelper = getOrganizationHelpers(organizationType);

  const text = `Вы всегда можете ознакомиться с\u00A0рейтингом\u00A0${orgHelper.namesType.mode9} России`;

  const handleButtonClick = () => {
    const link = makeFiltersLink({
      ...DEFAULT_FILTERS,
      organizationType,
    });
    document.location.href = link;
  };

  return (
    <div className={cx('wrapper', 'h-text-center')}>
      <Heading
        level={4}
        size={{
          mobile: 21,
          tablet: 22,
          desktop: 22,
        }}
        className="h-text-center"
      >
        Пока рейтинг недоступен
      </Heading>
      {text && (
        <Text size={14} className="h-text-center h-mt-8">
          {text}
        </Text>
      )}
      <Button className="h-mt-16" variant="primary" size={44} onClick={handleButtonClick}>
        Посмотреть
      </Button>
    </div>
  );
};
